
export const addGroupAction = function (item, form) {
    return {
        type: "FB_ADD_GROUP",
        payload: item, form
    }
};

export const setGroupsAction = function (items, form) {
    return {
        type: "FB_SET_GROUPS",
        payload: items, form
    }
};

export const removeGroupAction = function (item, form) {
    return {
        type: "FB_REMOVE_GROUP",
        payload: item, form
    }
};

export const clearGroupsAction = function () {
    return {
        type: "FB_CLEAR_GROUPS"
    }
};

export const changeGroupAction = function (item, form) {
    return {
        type: "FB_CHANGE_GROUP",
        payload: item, form
    }
};


// WEBPACK FOOTER //
// ./src/redux/creators/form-builder/groups.js